export const multiselect = {
  padding: {
    x: '10px',
    y: '10px',
  },
  borderRadius: '8px',
  colorScheme: {
    dark: {
      borderRadius: '8px',
      borderColor: '{content.borderColor}',
      background: '{blue.400}',
      hover: {
        borderColor: '{surface.0}',
      },
      overlay: {
        background: '{blue.400}',
        borderColor: '{content.borderColor}',
        borderRadius: '8px',
      },
      option: {
        borderRadius: '8px',
        focus: {
          background: '{blue.300}',
        },
      },
    },
  },
};
